export default "__VITE_ASSET__DsP1hZ8q__"